import React, { useState, useEffect, useCallback } from 'react'
import {
  Box, Button, Captcha, Form, Text,
} from '@usap/uicomponents'
import queryString from 'query-string'
import { Heading4 } from '../../../common/heading'
import FormField from '../../../Form/FormField'
import validate from '../../../../helpers/validation'
import { returnServiceGuestSchema } from '../../../common/ValidationSchema'
import InfoMessageBox from '../../../../helpers/infoMessageBox'
import GuestInfoRMAFormWmo from './GuestInfoRMAFormWmo'
import useIsWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'

const EMPTY_FORM_DATA = {
  emailAdd: '',
  orderId: '',
}

const loadFormDataFromUrlQuery = () => {
  if (typeof window === 'undefined') return EMPTY_FORM_DATA

  const { emailAdd, orderId } = queryString.parse(window.location.search)
  return { emailAdd, orderId }
}

const GuestInfoRMAForm = props => {
  const {
    Link,
    onSubmit,
    handleData,
    handleReason,
    siteKey,
  } = props
  const guestFormID = 'guestRMAFormID'
  const [formData, setFormData] = useState(loadFormDataFromUrlQuery())
  const [errors, setErrors] = useState({})
  const [requestError, setRequestError] = useState('')
  const [captcha, setCaptcha] = useState(false)

  const handleSubmit = useCallback(async () => {
    const error = validate(formData, returnServiceGuestSchema(formData))

    if (error) {
      return setErrors(error)
    }
    const submitData = await onSubmit(formData)
    if (submitData.error) {
      return setRequestError(submitData.message)
    }
    return handleData(submitData)
  }, [formData, onSubmit, handleData])

  const handleChange = useCallback(event => {
    const { name, value } = event.target
    setErrors({ ...errors, [name]: '' })
    setFormData({ ...formData, [name]: value })
  },
  [errors, formData])
  
  const isWmoEnabled = useIsWmoEnabled()

  useEffect(
    () => {
      if (captcha) {
        setErrors({ ...errors, captcha: false })
        setFormData({ ...formData, captcha })
      }
    },
    [captcha],
  )

  useEffect(
    () => {
      handleReason.scrollToElem('headerFirst')
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )

if(isWmoEnabled){
return (<GuestInfoRMAFormWmo {...props}/>)
}
  return (
    <>
      {requestError && (
        <InfoMessageBox message={requestError} type="error" />
      )}
      <Heading4
        id={guestFormID}
        size="small"
        color="dark-2"
        title="Return a Part"
        margin="0 0 10px 0"
      />
      <Text size="small" margin={{ bottom: '20px' }}>
        Please enter your email address and order number to file for return.
      </Text>
      <Form id="submitForm" onSubmit={handleSubmit}>
        <Box margin={{ bottom: '20px' }}>
          <FormField
            label="Email Address"
            placeholder=" "
            autoComplete="email-address"
            id="emailAdd"
            name="emailAdd"
            aria-label="email address"
            type="email"
            required
            error={errors.emailAdd}
            onChange={handleChange}
            defaultValue={formData.emailAdd}
          />
        </Box>
        <Box margin={{ bottom: '10px' }}>
          <FormField
            label="Order Number"
            placeholder=" "
            autoComplete="order-number"
            id="orderId"
            name="orderId"
            aria-label="order number"
            error={errors.orderId}
            onChange={handleChange}
            defaultValue={formData.orderId}
          />
        </Box>
        <Box pad={{ vertical: 'medium' }} align="center">
          <Captcha
            id="guest-form"
            name="guest-form-captcha"
            setCaptcha={setCaptcha}
            error={errors.captcha}
            siteKey={siteKey}
          />
        </Box>
        <Box margin={{ bottom: '20px' }}>
          <Button
            id="submitRMAGuest"
            form="submitForm"
            primary
            type="submit"
            custom
            hideBorder
            style={{ fontSize: 14 }}
            size="large"
            label="Start Return as Guest"
          />
        </Box>
        <Box align="center">
          <Text size="small" margin={{ bottom: '20px' }}>
            Have an account?
            {' '}
            <Link
              to="/myaccount/login?referrer=/myaccount/rma"
              style={{ color: '#05629B' }}
            >
              Sign In
            </Link>
          </Text>
        </Box>
      </Form>
    </>
  )
}

export default GuestInfoRMAForm
